import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class RealEstateCapitalGainError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('RealEstateCapitalGainError', ...args);
    }
}
export default RealEstateCapitalGainError;
